var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "ob1-popin-modal2",
        { attrs: { id: _vm.id, "aria-labelledby": "choisir" } },
        [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12 col-xl-6" }, [
              _c(
                "div",
                { staticClass: "h4 d-xl-none pb-2", attrs: { id: "choisir" } },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.accessory.name) +
                      "\n                "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col" }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 col-sm-8 col-xl-12" },
                  [
                    _vm.currentVersion.pictures.length > 0
                      ? _c("ob1-carrousel", {
                          attrs: {
                            id: _vm.id + "-gallery",
                            images: _vm.currentVersion.pictures,
                            "is-product-sheet": true,
                            "with-zoom": true,
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.accessory.das
                      ? _c(
                          "div",
                          { staticClass: "d-flex justify-content-center mb-1" },
                          [
                            _vm.accessory.das
                              ? _c("das-bundle-accessories", {
                                  attrs: {
                                    head: _vm.accessory.das.head,
                                    limbs: _vm.accessory.das.member,
                                    prefix: _vm.dasDto,
                                    trunk: _vm.accessory.das.trunk,
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col" }),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-12 col-xl-6" },
              [
                _c("div", { staticClass: "h4 d-none d-xl-block" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.accessory.name) +
                      "\n                "
                  ),
                ]),
                _vm._v(" "),
                _vm.showDeclinaisonName ? _c("ob1-separateur") : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12 col-md-6 col-xl-12" }, [
                    _vm.showDeclinaisonName
                      ? _c("div", {
                          staticClass: "fw-bold no-signature standard my-1",
                          domProps: {
                            innerHTML: _vm._s(_vm.currentVersion.name),
                          },
                        })
                      : _vm._e(),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-12 col-md-6 col-xl-12" },
                    [
                      _vm.accessory.versions.length > 1
                        ? _c(
                            "div",
                            { staticClass: "item-chips-capas" },
                            [
                              _vm.allColors.length > 1
                                ? _c("ob1-pastilles-de-couleurs", {
                                    ref: "pastilles-de-couleurs",
                                    staticClass: "mb-1",
                                    class: !_vm.showDeclinaisonName
                                      ? "mt-2"
                                      : null,
                                    attrs: {
                                      id: _vm.id + "-colors",
                                      colors: _vm.allColors,
                                      "default-color":
                                        _vm.currentVersion.color.code,
                                    },
                                    on: {
                                      "ob1-pastilles-de-couleurs-click":
                                        _vm.changeSelectedColor,
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.allCapacities.length > 1
                                ? _c(
                                    "fieldset",
                                    {
                                      class:
                                        _vm.allColors.length > 1
                                          ? "mb-1"
                                          : "mt-1 mb-1",
                                    },
                                    [
                                      _c(
                                        "legend",
                                        { staticClass: "visually-hidden" },
                                        [
                                          _vm._v(
                                            "\n                                    Capacités disponibles\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.allCapacities,
                                        function (capacity) {
                                          return _c("ob1-chips", {
                                            key:
                                              "capa-" +
                                              _vm.id +
                                              capacity.capacity,
                                            attrs: {
                                              id:
                                                _vm.id +
                                                "-capacity-" +
                                                capacity.capacity,
                                              "disable-uncheck": true,
                                              "is-checked": capacity.checked,
                                              "is-choice-version": true,
                                              "is-disabled": !capacity.inStock,
                                              label: capacity.capacity,
                                              "additional-classes": "mb-1",
                                            },
                                            on: {
                                              "ob1-chips-click": function (
                                                $event
                                              ) {
                                                return _vm.changeSelectedCapacity(
                                                  $event,
                                                  capacity.capacity
                                                )
                                              },
                                            },
                                          })
                                        }
                                      ),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.allLengths.length > 1
                                ? _c(
                                    "fieldset",
                                    {
                                      class:
                                        _vm.allCapacities.length > 1 ||
                                        _vm.allColors.length > 1
                                          ? "mb-1"
                                          : "mt-1 mb-1",
                                    },
                                    [
                                      _c(
                                        "legend",
                                        { staticClass: "visually-hidden" },
                                        [
                                          _vm._v(
                                            "\n                                    Longueurs disponibles\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.allLengths,
                                        function (length, index) {
                                          return _c("ob1-chips", {
                                            key:
                                              "length-" +
                                              _vm.id +
                                              length.length +
                                              index,
                                            ref: "access-length",
                                            refInFor: true,
                                            attrs: {
                                              id:
                                                _vm.id +
                                                "-length-" +
                                                length.length,
                                              "disable-uncheck": true,
                                              "is-checked": length.checked,
                                              "is-choice-version": true,
                                              "is-disabled": !length.inStock,
                                              label: length.length,
                                              "additional-classes": "mb-1",
                                            },
                                            on: {
                                              "ob1-chips-click": function (
                                                $event
                                              ) {
                                                return _vm.changeSelectedLength(
                                                  $event,
                                                  length.length
                                                )
                                              },
                                            },
                                          })
                                        }
                                      ),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentVersion.banner
                        ? _c(
                            "div",
                            { staticClass: "promo" },
                            [
                              _c("ob1-tag", {
                                attrs: { label: _vm.currentVersion.banner },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "price" },
                        [
                          _c("ob1-prix-terminal", {
                            staticClass: "mb-0",
                            attrs: {
                              "total-price-with-promo": _vm.priceWithPromo,
                              "total-price-without-promo":
                                _vm.priceWithoutDiscount,
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.currentVersion.ecoParticipation
                        ? _c("eco-part-private-copying", {
                            attrs: {
                              "eco-part-label":
                                _vm.currentVersion.ecoParticipation.label,
                              "private-copying-label":
                                _vm.currentVersion.ecoParticipation
                                  .privateCopyingLabel,
                              "private-copying-link":
                                _vm.currentVersion.ecoParticipation
                                  .privateCopyingLink,
                              "private-copying-link-label":
                                _vm.currentVersion.ecoParticipation
                                  .privateCopyingLinkLabel,
                              target:
                                _vm.currentVersion.ecoParticipation.modal
                                  .target,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "link",
                                  fn: function () {
                                    return [
                                      _c("ob1-liens", {
                                        staticClass: "fw-normal p-0",
                                        attrs: {
                                          "is-button": true,
                                          "modal-id": "popin-ecopart-" + _vm.id,
                                          text: _vm.currentVersion
                                            .ecoParticipation.linkLabel,
                                          type: "button",
                                        },
                                        on: {
                                          "ob1-liens-click":
                                            _vm.ecoPartLinkHandler,
                                        },
                                      }),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              2524347140
                            ),
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-12 col-sm-10 col-md-6 col-xl-12 pt-2 pb-1",
                    },
                    [
                      _vm.hasPromoOrOdr
                        ? _c("promo-odr", {
                            attrs: {
                              "promo-amount-in-cents": _vm.promoAmountInCents,
                              "promo-end-date": _vm.promoEndDate,
                              "odr-amount-in-cents": _vm.odrAmountInCents,
                              "odr-start-date": _vm.odrStartDate,
                              "odr-end-date": _vm.odrEndDate,
                              "bundle-pack-name": _vm.bundlePackName,
                              "promo-odr-messages": _vm.compactPromoMessagesDto,
                              "link-label":
                                _vm.compactPromoMessagesDto.linkLabel,
                              "modal-id": _vm.promoOdrPopinId,
                            },
                            on: {
                              "promo-odr-click": _vm.compactPromoOdrLinkHandler,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _vm.withButtonCta
                  ? _c(
                      "div",
                      {
                        staticClass: "row",
                        class: { "mb-3": _vm.sellerShopName == null },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "col-12" },
                          [
                            _c("p", [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.currentVersion.availabilityStatus)
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _vm.currentVersion.idSeo.value ===
                              _vm.displayVersionIdSeo && _vm.isAdded
                              ? _c("ob1-boutons", {
                                  attrs: {
                                    "is-disabled": false,
                                    "is-primary": true,
                                    label: _vm.deleteButtonLabel,
                                  },
                                  on: {
                                    "ob1-boutons-click":
                                      _vm.onDeleteButtonClick,
                                  },
                                })
                              : _c("ob1-boutons", {
                                  attrs: {
                                    "is-disabled": false,
                                    "is-primary": true,
                                    label: _vm.isAdded
                                      ? _vm.replaceButtonLabel
                                      : _vm.addButtonLabel,
                                  },
                                  on: {
                                    "ob1-boutons-click": _vm.onAddButtonClick,
                                  },
                                }),
                          ],
                          1
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.sellerShopName
                  ? _c("div", { staticClass: "row mb-2" }, [
                      _c(
                        "div",
                        { staticClass: "col-12 mt-2" },
                        [
                          _c("sold-by-card", {
                            attrs: {
                              title: _vm.sellerLabel,
                              "sold-by-orange": true,
                            },
                          }),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _vm.legalNoticesDas && _vm.accessory.das !== null
              ? _c("div", { staticClass: "col-12 pb-1" }, [
                  _c("p", {
                    domProps: { innerHTML: _vm._s(_vm.legalNoticesDas.text) },
                  }),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.legalNoticesSav !== null
              ? _c(
                  "div",
                  { staticClass: "col-12 pb-1" },
                  [
                    _c("ob1-separateur", { staticClass: "mb-2 mb-xl-3" }),
                    _vm._v(" "),
                    _c("h4", {
                      domProps: {
                        innerHTML: _vm._s(_vm.legalNoticesSav.title),
                      },
                    }),
                    _vm._v(" "),
                    _c("p", {
                      domProps: { innerHTML: _vm._s(_vm.legalNoticesSav.text) },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c("ob1-separateur", { staticClass: "mb-2 mb-xl-3" }),
                _vm._v(" "),
                _vm.accessory.longDescriptionTitle != null
                  ? _c("h4", {
                      domProps: {
                        innerHTML: _vm._s(_vm.accessory.longDescriptionTitle),
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.accessory.longDescription != null
                  ? _c("p", {
                      domProps: {
                        innerHTML: _vm._s(_vm.accessory.longDescription),
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _vm.otherLegalNotices.length > 0
                  ? _c("accessory-legal-notices", {
                      staticClass: "pb-1",
                      attrs: {
                        "legal-notices": _vm.otherLegalNotices,
                        title: "Mentions",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.currentVersion.ecoParticipation
        ? _c(
            "ob1-popin-modal2",
            {
              class: "popin-" + _vm.id,
              attrs: {
                id: "popin-ecopart-" + _vm.id,
                "aria-labelledby": "popin-ecopart-" + _vm.id + "-modal",
              },
            },
            [
              _c(
                "h4",
                { attrs: { id: "popin-ecopart-" + _vm.id + "-modal" } },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.currentVersion.ecoParticipation.modal.title) +
                      "\n        "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("p", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.currentVersion.ecoParticipation.modal.text
                  ),
                },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasPromoOrOdr
        ? _c("promo-odr-popin", {
            class: "popin-" + _vm.id,
            attrs: {
              "promo-amount-in-cents": _vm.promoAmountInCents,
              "promo-end-date": _vm.promoEndDate,
              "odr-amount-in-cents": _vm.odrAmountInCents,
              "odr-start-date": _vm.odrStartDate,
              "odr-end-date": _vm.odrEndDate,
              "odr-link": _vm.odrLink,
              "bundle-pack-name": _vm.bundlePackName,
              "device-name": _vm.deviceName,
              "device-discounted-price-in-cents":
                _vm.deviceDiscountedPriceInCents,
              "device-price-in-cents": _vm.devicePriceInCents,
              "promo-odr-messages": _vm.compactPromoMessagesDto,
              "modal-id": _vm.promoOdrPopinId,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }